import React from "react"
import { withStyles, WithStyles, createStyles, Theme } from "@material-ui/core"

import SectionItem from "./Section"
import { useGlobalLanguageText } from "../../../../utils/language"
import { Section } from "../../../../content/pages/global"
import { flexBreakpoint } from "./styles"

const styles = ({ breakpoints: { up } }: Theme) => {
  return createStyles({
    root: {
      marginBottom: "4.625rem",
      [up(flexBreakpoint)]: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "flex-start",
        marginBottom: "6.5rem",
      },
    },
  })
}

interface Props extends WithStyles<typeof styles> {}

const Sections = ({ classes }: Props) => {
  const {
    footer: { sections },
  } = useGlobalLanguageText()

  const renderSection = (section: Section): JSX.Element => {
    return <SectionItem {...section} key={section.name} />
  }

  const renderedSections: JSX.Element[] = sections.map(renderSection)

  return <div className={classes.root}>{renderedSections}</div>
}

export default withStyles(styles)(Sections)
